import axios from "axios";
import * as Constants from "../../../constants/Constants";

export function userRegistration(payload) {
    return new Promise(async (resolve, reject) => {
        let tenant = localStorage.getItem("tenant");
        axios.defaults.timeout = 60000;
        axios
            .post(
                process.env.REACT_APP_ACCESS_KEY + "/" + tenant + "/register",
                payload,
                {
                    headers: {
                        "Content-Type": Constants.CONTANT_TYPE,
                        "Authorization": `Bearer ${localStorage.getItem('signup_token')}`
                    }
                }
            )
            .then(res => {
                resolve(res);
            })
            .catch(error => {
                reject(error);
            });
    });
}

export function userSignIn(payload) {
    return new Promise(async (resolve, reject) => {
        let tenant = localStorage.getItem("tenant");
        axios.defaults.timeout = 60000;
        axios
            .post(
                process.env.REACT_APP_ACCESS_KEY + "/" + tenant + "/login",
                payload,
                {
                    headers: {
                        "Content-Type": Constants.CONTANT_TYPE
                    }
                }
            )
            .then(res => {
                resolve(res);
            })
            .catch(error => {
                reject(error);
            });
    });
}

export function forgotPassword(payload) {
    return new Promise(async (resolve, reject) => {
        let tenant = localStorage.getItem("tenant");
        axios.defaults.timeout = 60000;
        axios
            .post(
                process.env.REACT_APP_ACCESS_KEY +
                    "/" +
                    tenant +
                    "/forgot-password",
                payload,
                {
                    headers: {
                        "Content-Type": Constants.CONTANT_TYPE
                    }
                }
            )
            .then(res => {
                resolve(res);
            })
            .catch(error => {
                let errorData = {
                    error: true,
                    response: error.response,
                    code: error.code
                };
                reject(errorData);
            });
    });
}

export function resetPassword(payload) {
    return new Promise(async (resolve, reject) => {
        let tenant = localStorage.getItem("tenant");
        axios.defaults.timeout = 60000;
        axios
            .post(
                process.env.REACT_APP_ACCESS_KEY +
                    "/" +
                    tenant +
                    "/reset-password",
                payload,
                {
                    headers: {
                        "Content-Type": Constants.CONTANT_TYPE
                    }
                }
            )
            .then(res => {
                resolve(res);
            })
            .catch(error => {
                let errorData = {
                    error: true,
                    response: error.response,
                    code: error.code
                };
                reject(errorData);
            });
    });
}

export function sendOTP(payload) {
    return new Promise(async (resolve, reject) => {
        let tenant = localStorage.getItem("tenant");
        axios.defaults.timeout = 60000;
        axios.post(process.env.REACT_APP_ACCESS_KEY + "/" + tenant + "/phone/send-otp", payload, {
            headers: {
                "Content-Type": Constants.CONTANT_TYPE
            }
        })
        .then(res => {
            resolve(res);
        })
        .catch(error => {
            reject(error);
        });
    });
}

export function verifyOTP(payload) {
    return new Promise(async (resolve, reject) => {
        let tenant = localStorage.getItem("tenant");
        axios.defaults.timeout = 60000;
        axios.post(process.env.REACT_APP_ACCESS_KEY + "/" + tenant + "/phone/verify-otp", payload, {
            headers: {
                "Content-Type": Constants.CONTANT_TYPE,
                "Authorization": `Bearer ${localStorage.getItem('otp_token')}`
            }
        })
        .then(res => {
            resolve(res);
        })
        .catch(error => {
            reject(error);
        });
    });
}

export function resendOTP(payload) {
    return new Promise(async (resolve, reject) => {
        let tenant = localStorage.getItem("tenant");
        axios.defaults.timeout = 60000;
        axios.post(process.env.REACT_APP_ACCESS_KEY + "/" + tenant + "/phone/resend-otp", payload, {
            headers: {
                "Content-Type": Constants.CONTANT_TYPE
            }
        })
        .then(res => {
            resolve(res);
        })
        .catch(error => {
            reject(error);
        });
    });
}

export function updatePhoneNumber(payload) {
    return new Promise(async (resolve, reject) => {
        let token = localStorage.getItem("token");
        let tenant = localStorage.getItem("tenant");
        axios.defaults.timeout = Constants.AXIOS_DEFAULT_TIMEOUT;
        axios
            .post(
                `${process.env.REACT_APP_ACCESS_KEY}/${tenant}${Constants.UPDATE_PHONE_NUMBER_API_ROUTE}`,
                payload,
                {
                    headers: {
                        "Content-Type": Constants.CONTANT_TYPE,
                        Authorization: `Bearer ${token}`,
                    },
                }
            )
            .then((res) => {
                resolve(res);
            })
            .catch((error) => {
                reject(error);
            });
    });
}
